var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('SideBar'),_c('NavBar'),_c('div',{directives:[{name:"scrollbar",rawName:"v-scrollbar"}],staticClass:"content-height"},[_vm._t("default")],2),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }